var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9235 6.56728C15.6545 5.37819 14.0405 4.77273 12.2428 4.77273C9.05541 4.77273 6.35729 6.88135 5.39308 9.71538V9.71993C5.14819 10.4399 5.00905 11.209 5.00905 11.9999C5.00905 12.7908 5.14819 13.5599 5.39308 14.2799L5.39187 14.2809C6.35503 17.1167 9.05408 19.2271 12.2428 19.2271C13.8902 19.2271 15.2927 18.8016 16.3892 18.0816L16.3917 18.0836V18.082C17.6885 17.2311 18.5512 15.9602 18.835 14.4602H12.2454V9.81836H23.7773C23.922 10.6038 23.9999 11.422 23.9999 12.2729C23.9999 15.9275 22.6642 19.0038 20.3489 21.0929H20.3459C18.32 22.9254 15.5485 23.9998 12.2428 23.9998C7.45635 23.9998 3.31553 21.3107 1.30078 17.3889V17.386C0.472479 15.7667 0 13.9351 0 11.9999C0 10.0639 0.472899 8.23153 1.30189 6.61175L1.30078 6.61091C3.31553 2.68909 7.45635 0 12.2428 0C15.5432 0 18.3149 1.18909 20.4354 3.12546L16.9235 6.56728Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.66e429d3.svg";
export { ForwardRef as ReactComponent };